import React from "react"
import ReactApexChart from "react-apexcharts"

import KpiCard from "../parts/KpiCard"
import MetricHint from "../parts/MetricHint"
import {
	Card, EmptyNote, baseChartOptions, CHART_COLORS,
	convert, formatAmount, formatNumber, formatPercent, mutedStyle,
} from "../parts/common"

/**
 * Агенты. Главная колонка здесь не «сколько подключил», а «сколько его клиентов
 * живо через полгода»: агент, чьи клиенты отваливаются за квартал, приносит убыток,
 * сколько бы он ни подключил.
 */
function Agents({ data, currency, rates }) {
	const ranking = data.ranking || []

	const amount = (value) => formatAmount(convert(value, null, currency, rates), currency)

	const totals = ranking.reduce((acc, row) => ({
		new_points: acc.new_points + Number(row.new_points || 0),
		active_points: acc.active_points + Number(row.active_points || 0),
		mrr: acc.mrr + Number(row.mrr || 0),
	}), { new_points: 0, active_points: 0, mrr: 0 })

	const top = ranking.slice(0, 12)
	const chart = {
		options: {
			...baseChartOptions,
			chart: { ...baseChartOptions.chart, type: "bar", height: 340 },
			colors: [CHART_COLORS[0], CHART_COLORS[1]],
			plotOptions: { bar: { borderRadius: 4, horizontal: true, barHeight: "65%" } },
			xaxis: { ...baseChartOptions.xaxis, categories: top.map((row) => row.agent_name || row.agent_login) },
		},
		series: [
			{ name: "Новых точек", data: top.map((row) => row.new_points) },
			{ name: "Активных точек", data: top.map((row) => row.active_points) },
		],
	}

	return (
		<>
			<div className="row g-2 mb-3">
				<div className="col-md-3">
					<KpiCard title="Агентов" value={formatNumber(ranking.length)} sublabel="с закреплёнными точками" />
				</div>
				<div className="col-md-3">
					<KpiCard title="Подключений за период" value={formatNumber(totals.new_points)} accent="#1f9d57" />
				</div>
				<div className="col-md-3">
					<KpiCard title="Точек на сопровождении" value={formatNumber(totals.active_points)} />
				</div>
				<div className="col-md-3">
					<KpiCard title="MRR через агентов" hintKey="metric_mrr_hint" value={amount(totals.mrr)} accent="#9b5de5" />
				</div>
			</div>

			<div className="row g-2 mb-2">
				<div className="col-12">
					<Card title="Кто сколько подключил">
						{top.length === 0 && <EmptyNote>Нет данных за период</EmptyNote>}
						{top.length > 0 && (
							<ReactApexChart options={chart.options} series={chart.series} type="bar" height={340} />
						)}
					</Card>
				</div>
			</div>

			<Card title="Рейтинг агентов"
				right={<span style={mutedStyle}>удержание — доля клиентов агента старше полугода, которые ещё работают</span>}>
				{ranking.length === 0 && <EmptyNote>Нет данных</EmptyNote>}
				{ranking.length > 0 && (
					<div className="table-responsive">
						<table className="table table-sm table-hover table-bordered mb-0" style={{ fontSize: "12px" }}>
							<thead>
								<tr>
									<th>Агент</th>
									<th>Телефон</th>
									<th className="text-end">Новых точек</th>
									<th className="text-end">Активных точек</th>
									<th className="text-end">MRR</th>
									<th className="text-end">Оборот клиентов</th>
									<th className="text-end">Чеков</th>
									<th className="text-end">
										Удержание 6 мес. <MetricHint hintKey="metric_agent_retention_hint" />
									</th>
								</tr>
							</thead>
							<tbody>
								{ranking.map((row) => (
									<tr key={row.agent_id}>
										<td>{row.agent_name || row.agent_login}</td>
										<td style={mutedStyle}>{row.agent_phone || "—"}</td>
										<td className="text-end">{formatNumber(row.new_points)}</td>
										<td className="text-end">{formatNumber(row.active_points)}</td>
										<td className="text-end">{amount(row.mrr)}</td>
										<td className="text-end">{amount(row.gtv)}</td>
										<td className="text-end">{formatNumber(row.cheques)}</td>
										<td className="text-end" style={{
											color: row.retention_6m === null ? "inherit"
												: row.retention_6m >= 70 ? "#1f9d57" : "#d23434",
										}}>
											{row.retention_6m === null ? "—" : formatPercent(row.retention_6m)}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</Card>
		</>
	)
}

export default Agents
